import { registerComponent, asyncRequest, replaceDOM, loading } from "helpers";

registerComponent(
  "product-form",
  class ProductForm extends HTMLElement {
    SECTIONS_TO_RENDER = [
      {
        name: "cart-count",
        selector: "[data-cart-count]",
      },
      {
        name: "cart",
        selector: "[data-cart-items]",
      },
      {
        name: "cart",
        selector: "[data-free-shipping-message]",
      },
      {
        name: "cart",
        selector: "[data-cart-totals]",
      },
      {
        name: "cart",
        selector: "[data-cart-rewards]",
      },
      {
        name: "cart",
        selector: "[data-cart-checkout]",
      },
      {
        name: "cart",
        selector: "[data-cart-recommendations]",
      },
      {
        name: "product-details",
        selector: "[data-free-shipping-message]",
      },
    ];

    constructor() {
      super();

      this.form = this.querySelector("form");

      this.form.addEventListener("submit", this.handleSubmit.bind(this));
    }

    handleSubmit(event) {
      event.preventDefault();

      loading.add(this);
      this.addToCart();
    }

    getSectionNames() {
      return [
        ...new Set(this.SECTIONS_TO_RENDER.map((section) => section.name)),
      ].join(",");
    }

    getBody() {
      const formData = new FormData(this.form);

      const propertiesRegex = /properties\[(.*?)\]/;
      const attributesRegex = /attributes\[(.*?)\]/;

      const body = {
        items: [
          {
            id: formData.get("id"),
            quantity: formData.get("quantity"),
            properties: {},
          },
        ],
        sections: this.getSectionNames(),
        attributes: {},
      };

      // Add cart attributes or line item properties to body
      Array.from(formData).forEach(([name, value]) => {
        const propertiesMatch = propertiesRegex.exec(name);
        const attributesMatch = attributesRegex.exec(name);

        if (propertiesMatch && propertiesMatch.length > 1) {
          body.items[0].properties[propertiesMatch[1]] = value;
        }

        if (attributesMatch && attributesMatch.length > 1) {
          body.attributes[attributesMatch[1]] = value;
        }
      });

      return body;
    }

    async addToCart() {
      const body = this.getBody();
      const options = {
        ...WYATT.config.fetch.post,
        ...{ body: JSON.stringify(body) },
      };

      const addedToCartResponse = await asyncRequest(
        `${WYATT.routes.cart_add_url}.js`,
        options,
        {
          messageOptions: {
            minDelay: 6000,
            appendPoint:
              "[data-mini-cart] [data-drawer-messages], #page-messages",
          },
        },
      );

      const data = JSON.parse(addedToCartResponse);

      if (data?.sections) {
        this.handleSuccessfulAdd(data.sections);
      } else {
        this.handleUnsuccessfulAdd();
      }

      loading.remove(this);

      document.querySelector('[data-drawer-open="[data-mini-cart]"]').click();
    }

    handleSuccessfulAdd(sections) {
      this.updateSections(sections);
    }

    async handleUnsuccessfulAdd() {
      const sectionsData = await asyncRequest(
        `${window.location.pathname}?sections=${this.getSectionNames()}`,
        {},
        {
          responseFormat: "json",
        },
      );

      if (sectionsData) {
        this.updateSections(sectionsData);
      }
    }

    updateSections(data) {
      this.SECTIONS_TO_RENDER.forEach((section) =>
        replaceDOM(data[section.name], section.selector),
      );
    }
  },
);
